import Breadcrumb from './../components/BreadCrumb';
import AboutMoreSection from './../sections/AboutMoreSection';
import AboutUsSection from './../sections/AboutUsSection';
import HeadingDetailsSection from './../sections/HeadingDetailsSection';
import ValueSection from './../sections/ValueSection';
import WhyChooseUsSection from './../sections/WhyChooseUs';

function AboutUsScreen() {
  return (
    <>
        <HeadingDetailsSection heading='About Us'>
          <Breadcrumb screen='About Us'/>
        </HeadingDetailsSection>
        <AboutUsSection/>
        <WhyChooseUsSection/>
        <ValueSection/>
        <AboutMoreSection/>
    </>
  );
}

export default AboutUsScreen;
